// OPTIMIZED: Replaced @fortawesome with lightweight custom SVG icons
import React from 'react';
import { 
  CoffeeIcon, 
  CloudSunIcon, 
  ClockIcon, 
  PartneredIcon, 
  UncoveredIcon, 
  ArrowCircleUpIcon, 
  ArrowCircleDownIcon, 
  CircleChevronUpIcon, 
  RouteIcon, 
  StarIcon, 
  UpDownIcon
} from '../../Icons';

export enum SORT_KEYS {
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  RATING_HIGH_TO_LOW = "RATING_HIGH_TO_LOW",
  RATING_LOW_TO_HIGH = "RATING_LOW_TO_HIGH",
  DISTANCE_NEAREST = "DISTANCE_NEAREST_FIRST",
  TURF_HEIGHT = "TURF_HEIGHT"
}

export const SORT_LABELS = {
  PRICE_HIGH_TO_LOW: "PRICE HIGH TO LOW",
  PRICE_LOW_TO_HIGH: "PRICE LOW TO HIGH",
  RATING_HIGH_TO_LOW: "RATING HIGH TO LOW",
  RATING_LOW_TO_HIGH: "RATING LOW TO HIGH",
  DISTANCE_NEAREST: "DISTANCE NEAREST FIRST",
  TURF_HEIGHT: "TURF HEIGHT"
};

export const sortOptions = [
  {
    key: SORT_KEYS.PRICE_LOW_TO_HIGH,
    label: SORT_LABELS.PRICE_LOW_TO_HIGH,
  },
  {
    key: SORT_KEYS.PRICE_HIGH_TO_LOW,
    label: SORT_LABELS.PRICE_HIGH_TO_LOW,
  },
  {
    key: SORT_KEYS.RATING_HIGH_TO_LOW,
    label: SORT_LABELS.RATING_HIGH_TO_LOW,
  },
  {
    key: SORT_KEYS.RATING_LOW_TO_HIGH,
    label: SORT_LABELS.RATING_LOW_TO_HIGH,
  },
  {
    key: SORT_KEYS.DISTANCE_NEAREST,
    label: SORT_LABELS.DISTANCE_NEAREST,
  },
  {
    key: SORT_KEYS.TURF_HEIGHT,
    label: SORT_LABELS.TURF_HEIGHT,
  },
  
];
export const SORT_ICONS: Record<SORT_KEYS, React.ComponentType<any>> = {
  [SORT_KEYS.PRICE_LOW_TO_HIGH]: ArrowCircleUpIcon,
  [SORT_KEYS.PRICE_HIGH_TO_LOW]: ArrowCircleDownIcon,
  [SORT_KEYS.RATING_HIGH_TO_LOW]: StarIcon,
  [SORT_KEYS.RATING_LOW_TO_HIGH]: CircleChevronUpIcon,
  [SORT_KEYS.DISTANCE_NEAREST]: RouteIcon,
  [SORT_KEYS.TURF_HEIGHT]: UpDownIcon,
};
export enum FILTERS_KEYS {
  CAFE = "CAFE",
  COVERED = "COVERED",
  OPEN_24_7 = "OPEN_24_7",
  PARTNERED = "PARTNERED",
  UNCOVERED = "UNCOVERED",
}

export const FILTERS_LABELS = {
  CAFE: "CAFE",
  COVERED: "COVERED",
  OPEN_24_7: "OPEN 24*7",
  PARTNERED: "PARTNERED",
  UNCOVERED: "UNCOVERED",
};

export const FILTERS_ICONS: Record<FILTERS_KEYS, React.ComponentType<any>> = {
  [FILTERS_KEYS.CAFE]: CoffeeIcon,
  [FILTERS_KEYS.COVERED]: CloudSunIcon,
  [FILTERS_KEYS.OPEN_24_7]: ClockIcon,
  [FILTERS_KEYS.PARTNERED]: PartneredIcon,
  [FILTERS_KEYS.UNCOVERED]: UncoveredIcon,
};

// Size range filter disabled — UI and filtering logic commented out
// export enum SIZE_RANGE {
//   MIN = 2000,
//   MAX = 100000,
// }

export const DISTANCE_RANGE_MAX = 30

export enum FILTER_PICKLEBALL_KEYS {
  CONCRETE_COURT = "CONCRETE_COURT",
  ASPHALT_COURT = "ASPHALT_COURT", 
  ACRYLIC_COATED_COURT = "ACRYLIC_COATED_COURT",
  MODULAR_TILE_COURT = "MODULAR_TILE_COURT",
  SYNTHETIC_TURF_COURT = "SYNTHETIC_TURF_COURT",
  CUSHIONED_ACRYLIC_COURT = "CUSHIONED_ACRYLIC_COURT"
}